import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/link.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import { RouterLinkPropType, InnerRefPropType } from '../../packages/props-utils/prop-types.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bem = new HoneyBem('link', styles);
function Link(_a) {
  var {
      children,
      extraClasses,
      innerRef,
      RouterLink
    } = _a,
    rest = __rest(_a, ["children", "extraClasses", "innerRef", "RouterLink"]);
  if (RouterLink) {
    return /*#__PURE__*/React.createElement(RouterLink, Object.assign({
      className: bem.b(false, extraClasses),
      to: rest.href || rest.to || ''
    }, innerRef ? {
      innerRef
    } : {}, rest), children);
  }
  return /*#__PURE__*/React.createElement("a", Object.assign({
    ref: innerRef,
    className: bem.b(false, extraClasses)
  }, rest), children);
}
Link.displayName = 'Link';
Link.propTypes = {
  children: PropTypes.node.isRequired,
  extraClasses: PropTypes.string,
  innerRef: InnerRefPropType,
  RouterLink: RouterLinkPropType
};
var link = Injecss(Link, styles);

export { Link, link as default };
